import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { ScreenLinkService } from 'features/project/url-params/service/service'

export { ScreenLinkService } from 'features/project/url-params/service/service'

export function useScreenLinkService(): ScreenLinkService {
  const client = useApiClient()
  return useMemo(() => new ScreenLinkService(client), [client])
}
